import { render, staticRenderFns } from "./JoinMamModal.vue?vue&type=template&id=604be69f&scoped=true"
import script from "./JoinMamModal.vue?vue&type=script&lang=js"
export * from "./JoinMamModal.vue?vue&type=script&lang=js"
import style0 from "./JoinMamModal.vue?vue&type=style&index=0&id=604be69f&prod&lang=scss&scoped=true"
import style1 from "./JoinMamModal.vue?vue&type=style&index=1&id=604be69f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604be69f",
  null
  
)

export default component.exports